import Axios from "../../../utils/union-axios";

/**
 * 批量查询商品详情
 */
export function BatchQueryGoodsDetail(data) {
  return Axios.post(`/web-h5/charge/member/batchQueryGoods`, data);
}

/**
 * 根据uid查询用户充电省钱团成员身份
 */
export function GetUserMembership(data) {
  return Axios.get(`/web-h5/charge/member/getUserMembership`, data);
}

/**
 * 获取小鹏车主终身享省钱团特权说明
 */
export function GetXpOwnerPrivilege(data) {
  return Axios.get(`/web-h5/charge/member/getXpOwnerPrivilege`, data);
}

/**
 * 查看券包商品列表
 */
export function GetCouponPackGoods(data) {
  return Axios.get(`/web-h5/charge/member/queryCouponPackGoods`, data);
}

/**
 * 查看可购买的VIP卡列表
 */
export function GetMemberCardGoods(data) {
  return Axios.get(`/web-h5/charge/member/queryMemberCardGoods`, data);
}

/**
 * 查看可购买的VIP卡列表
 */
export function GetMemberCardGoodsV2(data) {
  return Axios.get(`/web-h5/charge/member/queryMemberCardGoodsV2`, data);
}

/**
 * 查看特权说明
 */
export function GetPrivilegeDesc() {
  return Axios.get(`/web-h5/charge/member/getPrivilegeDesc`);
}

/**
 * 用户券包获取记录
 */
export function PostUserCouponPackRecords(data) {
  return Axios.post(`/web-h5/charge/member/queryUserCouponPackRecords`, data);
}

/**
 * 用户省钱卡获取记录
 */
export function PostUserMemberCardRecords(data) {
  return Axios.post(`/web-h5/charge/member/queryUserMemberCardRecords`, data);
}

/**
 * 预购买省钱团商品
 */
export function PostPreBuyMemberGoods(data) {
  return Axios.post(`/web-h5/charge/member/preBuyMemberGoods`, data);
}

/**
 * 查询VIP站点列表
 */
export function GetQueryStationList(data) {
  return Axios.post(`/web-h5/charge/member/queryStationList`, data);
}

/**
 * 查询VIP卡券获得记录
 */
export function GetQueryMyGoodsRecord(data) {
  return Axios.post(`/web-h5/charge/member/queryMyGoodsRecord`, data);
}

/**
 * 查看用户当前已有的VIP产品
 */
export function GetMyMemberGoods() {
  return Axios.get(`/web-h5/charge/member/queryMyMemberGoods`);
}

/**
 * 查看红包列表
 */
export function queryDiscountCouponPage(data) {
  return Axios.post(`/web-h5/charge/member/queryDiscountCouponPage`, data);
}

/**
 * 获取用户信息
 */
export function getCurrentUserInfo() {
  return Axios.get(`/web-h5/charge/member/getCurrentUserInfo`);
}

/**
 * 点击领券
 */
export function getDiscountCoupon(data) {
  return Axios.post(`/web-h5/charge/member/getDiscountCouponByUser`, data);
}

/**
 * 省钱汇总信息
 */
export function GetDeductInfo(data) {
  return Axios.get(`/web-h5/charge/member/memberDeductInfo`, data);
}

/**
 * 省钱明细信息
 */
export function GetDeductDetailList(data) {
  return Axios.get(`/web-h5/charge/member/memberDeductDetailList`, data);
}

/**
 * 根据UID查询用户会员信息
 */
export function GetUserMembershipLevel() {
  return Axios.get(`/web-h5/charge/member/getUserMembershipLevel`, {});
}

/**
 * 头部专区权益概览
 */
export function GetBenefitIcon() {
  return Axios.get(`/web-h5/charge/member/getBenefitIcon`, {});
}

/**
 * 权益介绍入口
 */
export function GetBenefitIntroduce() {
  return Axios.get(`/web-h5/charge/member/getBenefitIntroduce`, {});
}

/**
 * 用户电力下发明细
 */
export function queryPowerValueRecord(data) {
  return Axios.post(`/web-h5/charge/member/queryPowerValueRecord`, data);
}

/**
 * 根据用户id查询用户等级变更记录
 */
export function queryUserVipLevelChangeRecord(data) {
  return Axios.post(
    `/web-h5/charge/member/queryUserVipLevelChangeRecord`,
    data,
  );
}

/**
 * 查询券包实例发放周期详情
 */
export function GetCycleDetail(userCouponPackRefId: string) {
  return Axios.post(`/web-h5/charge/member/userCouponPackRef/cycleDetail`, {
    userCouponPackRefId,
  });
}

/**
 * 查看VIP商品列表
 */
export function GetMemberGoods() {
  return Axios.get(`/web-h5/charge/member/indexMemberGoods`);
}

/**
 * 查看VIP商品列表
 */
export function GetMemberGoodList() {
  return Axios.get(`/web-h5/charge/member/getMemberGoodList`);
}
